import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HighchartsChartComponent } from 'highcharts-angular';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TreemapComponent } from './treemap/treemap.component';
import { BubbleComponent } from './bubble/bubble.component';
import { ThresholdChartComponent } from './threshold-chart/threshold-chart.component';
import { MLComparisonChartComponent } from './ml-comparison-chart/ml-comparison-chart.component';
import { MLPerformanceDistributionComponent } from './ml-performance-distribution/ml-performance-distribution.component';

@NgModule({
  declarations: [TreemapComponent, BubbleComponent, MLComparisonChartComponent, MLPerformanceDistributionComponent, ThresholdChartComponent],
  imports: [CommonModule, FormsModule, HighchartsChartComponent, NzToolTipModule, NzSliderModule, AngularSvgIconModule],
  exports: [TreemapComponent, BubbleComponent, MLComparisonChartComponent, MLPerformanceDistributionComponent, HighchartsChartComponent, ThresholdChartComponent]
})
export class ChartsSharedModule {}
